import React from 'react';
import { DeleteRegularIcon } from 'src/monet/icons';
import { ContextMenuButton } from './components/context-menu-button';
import { useEditorStore } from './editor-store';
import { Section } from './types';

type Props = {
  section: Section;
};

export const EmptySectionContextMenuContent = ({ section }: Props) => {
  const dispatchUserEditorAction = useEditorStore((state) => state.dispatchUserEditorAction);
  const clearContextMenuState = useEditorStore((state) => state.clearContextMenuState);

  const onDeleteSection = () => {
    dispatchUserEditorAction({
      type: 'delete-section',
      id: section.id,
    });
    clearContextMenuState();
  };
  return (
    <>
      <ContextMenuButton onClick={onDeleteSection} label='Delete empty section'>
        <DeleteRegularIcon className='w-4 h-4' />
      </ContextMenuButton>
    </>
  );
};
